import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';

const Notification = ({ message, type = 'info', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = {
    success: FiCheckCircle,
    error: FiAlertCircle,
    info: FiInfo
  };

  const colors = {
    success: 'border-green-500 text-green-400',
    error: 'border-red-500 text-red-400',
    info: 'border-electric text-electric'
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 50, scale: 0.9 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 20, scale: 0.9 }}
      className={`fixed bottom-6 right-6 z-[100] dashboard-panel p-4 flex items-center gap-4 min-w-[300px] border-l-4 shadow-2xl ${colors[type]}`}
      role="alert"
    >
      <SafeIcon icon={icons[type]} className="text-xl" />
      <div className="flex-grow">
        <div className="fids-text text-[10px] uppercase opacity-60">System_Message</div>
        <div className="fids-text text-xs font-bold text-white uppercase tracking-tight">{message}</div>
      </div>
      <button 
        onClick={onClose}
        className="p-1 hover:bg-white/10 rounded transition-colors"
        aria-label="Dismiss notification"
      >
        <SafeIcon icon={FiX} />
      </button>
    </motion.div>
  );
};

export default Notification;